module.exports = __webpack_public_path__ + "img/album13_10.f0531990.jpg";